var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DxCheckBox',{attrs:{"disabled":_vm.model.disabled,"value":_vm.content.value,"text":_vm.model.label.name},on:{"update:value":function($event){return _vm.$set(_vm.content, "value", $event)},"value-changed":function($event){return _vm.onValueChanged()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }